// extracted by mini-css-extract-plugin
export default {"container":"ActivityDetails__container___FPust","description":"ActivityDetails__description___zDr9P"};